import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GlobalStyleReset: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        // 1. Reset Body Styles (Aggressive)
        document.body.style.overflow = '';
        document.body.style.overflowX = '';
        document.body.style.overflowY = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.width = '';
        document.body.style.height = '';

        // 2. Remove Jodit-specific classes with Search & Destroy (Aggressive)
        const classesToRemove = ['jodit_fullsize_box', 'jodit_fullsize_box_true', 'jodit_fullsize-box_true'];
        classesToRemove.forEach(className => {
            const affectedElements = document.querySelectorAll(`.${className}`);
            affectedElements.forEach(el => {
                el.classList.remove(className);
            });
        });

        // 3. Remove orphaned Jodit fullsize DOM elements if they exist
        // Sometimes Jodit leaves the editor container appended to body in fullscreen mode
        const orphanedEditors = document.querySelectorAll('.jodit_fullsize');
        orphanedEditors.forEach(el => {
            // We can't safely remove them as they might be component roots, 
            // but we can strip the class that makes them cover the screen.
            el.classList.remove('jodit_fullsize');
            (el as HTMLElement).style.zIndex = '';
            (el as HTMLElement).style.position = '';
            (el as HTMLElement).style.top = '';
            (el as HTMLElement).style.left = '';
            (el as HTMLElement).style.width = '';
            (el as HTMLElement).style.height = '';
        });

        // 4. Force strict layout recalc (optional, but good for "blank" canvas issues)
        window.dispatchEvent(new Event('resize'));

    }, [location.pathname]); // Run on route path change (ignore state/hash changes)

    return null;
};

export default GlobalStyleReset;
